import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import {
  Profil,
  ProfilCreateInput,
  ProfilFilters,
  ProfilListResponse,
  ProfilResponse,
  ProfilSelectOption,
  ProfilUpdateInput
} from '../types/profil';
import { BaseApiService } from './base-api.service';

export class ProfilService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.PROFILS.BASE, axios);
  }

  async getProfils(filters: ProfilFilters = {}): Promise<ProfilListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Profil>({ page, limit, ...rest });
  }

  async getProfilById(id: number): Promise<ProfilResponse> {
    return this.get<ProfilResponse>(`/${id}`);
  }

  async createProfil(data: ProfilCreateInput): Promise<ProfilResponse> {
    return this.post<ProfilResponse, ProfilCreateInput>('', data);
  }

  async updateProfil(id: number, data: ProfilUpdateInput): Promise<ProfilResponse> {
    return this.put<ProfilResponse, ProfilUpdateInput>(`/${id}`, data);
  }

  async deleteProfil(id: number): Promise<ProfilResponse> {
    return this.delete<ProfilResponse>(`/${id}`);
  }

  async getProfilOptions(): Promise<ProfilSelectOption[]> {
    return this.get<ProfilSelectOption[]>('/select');
  }
}
